











































































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component({})
export default class ConnectWalletOption extends Vue {
  @Prop({type: Boolean, required: true}) isDisabled!: boolean
  @Prop({type: Boolean, default: false}) isDownloadAvailable!: boolean
  @Prop({type: Function, required: true}) connectWallet!: () => Promise<void>
  @Prop({type: String, required: true}) walletTitle!: string
  @Prop({type: String, default: ''}) walletSubtitle!: string
  @Prop({type: String, required: true}) walletIcon!: string
  @Prop({type: Boolean, default: false}) highlightContainer!: boolean

  async onConnectClick() {
    await this.connectWallet()
  }
}
